import { AxiosHeaders } from 'axios';
import { captureException } from '@sentry/vue';

const HEADER = 'X-Refrag-View';

let reported = false;

// "https://...", "blob:..." or "//host/...": anything else axios joins onto baseURL.
const ABSOLUTE_URL = /^([a-z][a-z\d+.-]*:|\/\/)/i;

function isApiRequest(url = '', baseURL = '') {
  return !ABSOLUTE_URL.test(url) || Boolean(baseURL && url.startsWith(baseURL));
}

// Tells the backend which page made a request, so its coach events can tell /coach from the
// home page's coach widget. The route name only, never the path: no match id or slug leaves.
// Only the API gets it: the demo upload shares this axios and goes to another host, where an
// unknown header can fail the CORS preflight.
// eslint-disable-next-line import-x/prefer-default-export
export function installViewHeader(axiosInstance, router) {
  axiosInstance.interceptors.request.use((config) => {
    try {
      const name = router.currentRoute.value?.name;

      if (typeof name === 'string' && name
        && isApiRequest(config.url, axiosInstance.defaults.baseURL)) {
        // vue-auth's axios driver runs first and turns config.headers into a plain object.
        const headers = AxiosHeaders.from(config.headers);

        if (!headers.has(HEADER)) {
          headers.set(HEADER, name);
        }
        return { ...config, headers };
      }
    } catch (e) {
      // Labelling a request is never worth failing it, but a silent catch hid a broken header
      // for two days, so report the first failure of each page load.
      if (!reported) {
        reported = true;
        captureException(e, { tags: { feature: 'wi_73f9293a-d71c-4168-8f86-c66560bac353' } });
      }
    }

    return config;
  });
}
